import { useResizeDetector as useReactResizeDetector } from 'react-resize-detector';

export default function useResizeDetector (opts = {}) {
  return useReactResizeDetector({
    refreshMode: 'debounce',
    refreshRate: 0,
    ...opts,
  });
}
